// extracted by mini-css-extract-plugin
module.exports = {"elevatorAnimation":"elevator_animation_elevatorAnimation__1ciot","shaft":"elevator_animation_shaft__IoFNK","elevator":"elevator_animation_elevator__oyibu"};